module.exports = __webpack_public_path__ + "static/media/logo.15fdda66.svg";